module.exports = __webpack_public_path__ + "static/media/bg_log.c8d9627e.webp";